<!--
删除记录的弹窗
-->
<template>
  <el-dialog class="lc-delete-confirm-dialog" title="删除确认" :visible.sync="visible" width="500px">
    <div class="clearfix">
      <div class="pull-left"><i class="el-icon-delete-solid icon"></i></div>

      <div class="pull-left m-l-10" style="width: 420px">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span class="content" v-html="contentHtml || defaultContentHtml()"></span>
      </div>
    </div>

    <!-- 脚本 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.btn.cancel') }}</el-button>
      <el-button type="danger" @click="handleConfirm">{{ $t('common.btn.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // visible
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      // 删除记录的名字
      recordName: '',
      // 删除的记录
      record: null,
      // 删除方法。参数返回 record 信息
      deleteConfirmMethod: null,
      contentHtml: ''
    }
  },
  watch: {
    value() {
      this.visible = this.value
    },
    // 弹窗
    visible() {
      this.emitInputEvent()
    }
  },
  created() {
    this.visible = this.value // 初始化弹窗的状态
  },
  methods: {
    /**
     * 发送 input 事件
     */
    emitInputEvent() {
      this.$emit('input', this.visible)
    },
    /**
     * 弹窗
     *
     * @param {string} recordName 删除的记录名称
     * @param {object} record 删除的记录
     * @param {Function} deleteConfirmMethod 删除确认的回调方法，回调方法有返回参数 record。主要用于调用删除 API
     * @param {string} contentHtml 提示内容
     */
    popup(recordName, record, deleteConfirmMethod, contentHtml) {
      this.visible = true
      this.recordName = recordName
      this.record = record
      this.deleteConfirmMethod = deleteConfirmMethod
      this.contentHtml = contentHtml
    },
    /**
     * 确认
     */
    handleConfirm() {
      this.visible = false

      // 调用删除方法
      this.deleteConfirmMethod.call(this, this.record)
    },
    defaultContentHtml() {
      let prefix = this.$t('common_component.lc_delete_confirm_dialog.delete_confirm_prefix')
      let suffix = this.$t('common_component.lc_delete_confirm_dialog.delete_confirm_suffix')

      return `${prefix} <span style="font-size: 20px;" class="lc-primary-color">${this.recordName}</span> ${suffix}`
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-delete-confirm-dialog {
  .icon {
    font-size: 20px;
    color: #f56c6c;
    margin-top: 5px;
  }
  .record-name {
    font-size: 20px;
  }
  .content {
    ::v-deep * {
      all: revert;
    }
  }
}
</style>
